import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  PATH_ABOUT,
  PATH_ABOUT_SECTION,
  PATH_CONTACT,
  PATH_CONTACT_SECTION,
  PATH_HOME_SECTION,
  PATH_PORTFOLIO,
  PATH_PORTFOLIO_SECTION,
  PATH_SERVICE,
  PATH_SERVICES_SECTION,
} from "../../../utility/constants";
import Images from "../../../utility/imagePaths";
import Button from "../../common/buttons/button/Button";
import "./AppHeader.css";

const AppHeader = () => {
  const navigate = useNavigate();
  const [showDrawer, setShowDrawer] = useState(false);
  const navItems = [
    { path: "/", label: "Home", title: "View Home" },
    { path: PATH_SERVICE, label: "Services", title: "View Services" },
    {
      path: PATH_PORTFOLIO,
      label: "Portfolio",
      title: "View Portfolio",
    },
    { path: PATH_ABOUT, label: "About", title: "About JD SoftTech" },
    { path: PATH_CONTACT, label: "Contact", title: "Contact Us" },
  ];
  const onClickMenu = () => {
    setShowDrawer(!showDrawer);
  };

  const onClickMobileGetStarted = () => {
    setShowDrawer(false);
    navigate(PATH_CONTACT);
  };

  return (
    <>
      <header className="appHeader_container">
        <div className="appHeader_subContainer">
          <h1 className="logo">
            <NavLink
              to="/"
              aria-label="JD SoftTech Home"
              className=" gradient_text"
            >
              JD SoftTech
            </NavLink>
          </h1>
          <nav className="display_none_mobile">
            <ul>
              {navItems.map(({ path, label, title }) => (
                <li key={path}>
                  <NavLink
                    to={path}
                    className={({ isActive }) =>
                      isActive ? "navLink activeLink" : "navLink"
                    }
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
          <Button
            title="Get Started"
            onClickButton={() => navigate(PATH_CONTACT)}
            backgroundColor="linear-gradient(135deg, hsl(214 84% 56%), hsl(263 70% 50%))"
            className="getStart_btn display_none_mobile"
          />
          <img
            src={showDrawer ? Images.SVG_CLOSE_ICON : Images.SVG_MENU_ICON}
            alt="Menu"
            className="hameburgur"
            onClick={onClickMenu}
          />
        </div>
        {showDrawer && (
          <div className="navBar_mobile_container">
            <nav>
              <ul className="navBar_mobile_subContainer">
                {navItems.map(({ path, label, title }) => (
                  <li key={path}>
                    <NavLink
                      to={path}
                      className={({ isActive }) =>
                        isActive ? "navLink activeLink" : "navLink"
                      }
                      onClick={() => setShowDrawer(false)}
                    >
                      {label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>
            <Button
              title="Get Started"
              // path={"#" + PATH_CONTACT_SECTION}
              // pathType="_self"
              onClickButton={onClickMobileGetStarted}
              backgroundColor="linear-gradient(135deg, hsl(214 84% 56%), hsl(263 70% 50%))"
              className="getStart_btn "
            />
          </div>
        )}
      </header>
    </>
  );
};

export default AppHeader;
